import { render, staticRenderFns } from "./ModalQuickBuyInfo.vue?vue&type=template&id=c1dffcd2&scoped=true&"
import script from "./ModalQuickBuyInfo.vue?vue&type=script&lang=js&"
export * from "./ModalQuickBuyInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalQuickBuyInfo.vue?vue&type=style&index=0&id=c1dffcd2&lang=scss&scoped=true&"
import style1 from "./ModalQuickBuyInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dffcd2",
  null
  
)

export default component.exports